import styled from 'styled-components'

import { Text } from '@radix-ui/themes'

export const StyledRelativeTimeDisplay = styled(Text)`
    width: fit-content;
`
